
import { filter } from 'lodash';

export function hasRegTypeCapacityWarning(state) {
  const message = filter(state.registrationForm.validationMessages || [],
    validationMessage => (validationMessage.localizationKey === 'REGAPI.CAPACITY_UNAVAILABLE'
      && validationMessage.parametersMap && validationMessage.parametersMap.entityType === 'ContactType'));
  if (message.length > 0) {
    return true;
  }
  return false;
}
